import React, { useState } from "react";

import { Alert, Link } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";
import type { NapiUser } from "@app/types/napi-types";

import { clickedResendEmailVerification } from "../../../../tracking/account-tracking";

interface Props {
  user: NapiUser;
}

export const AccountVerification: React.FC<Props> = ({ user }) => {
  const { api, translator, sentry, tracker } = useAppContext();
  const [is_email_sent, setEmailAsSent] = useState(false);
  if (!user || !!user.verified_at) {
    return null;
  }

  const handleClick = () => {
    tracker.track(clickedResendEmailVerification());
    setEmailAsSent(true);
    api.resendVerificationEmail(user.email).catch(() => {
      setEmailAsSent(false);
      // @ts-expect-error
      sentry.captureException(new Error("ResendVerificationEmailError"), {
        tags: {
          page: "account",
          component: "AccountVerification"
        }
      });
    });
  };

  return (
    <Alert>
      <Alert.Title as="span">
        {translator.t("!account.verification.title")}
      </Alert.Title>
      <Alert.Description className="gap-300">
        {translator.t("!account.verification.message")}{" "}
        {is_email_sent ? (
          translator.t("!account.verification.email-sent")
        ) : (
          <Link onClick={handleClick} isMonochrome>
            {translator.t("!account.verification.resend-email")}
          </Link>
        )}
      </Alert.Description>
    </Alert>
  );
};
